module.exports = __webpack_public_path__ + "static/media/hw_yo_38.b9add464.flv";